import React from 'react';
import { Box, Typography } from '@mui/material';
import { IEventAsset } from '@providers/EventProvider/interfaces';
import { useStyles } from './styles';
import { useTrainerToolsContent as useTrainerTools } from '@features/TrainerTools/provider';

const ObjectItem = ({ item }: { item: IEventAsset }) => {
  const classes = useStyles();

  const { setTemporaryObject, temporaryObject } = useTrainerTools();

  const handleClick = () => {
    setTemporaryObject(item);
  };

  const isActive =
    !!temporaryObject && temporaryObject.assetId === item.assetId;

  return (
    <Box sx={classes.root(isActive)} onClick={handleClick}>
      {item?.data &&
      'previewImage' in item.data &&
      item?.data?.previewImage?.url ? (
        <img src={item?.data?.previewImage.url} />
      ) : (
        <Box sx={classes.placeholder} />
      )}

      <Typography sx={classes.title}>{item.name}</Typography>
    </Box>
  );
};

export default ObjectItem;
